import { render, staticRenderFns } from "./CreateAssessmentTemplateModal.vue?vue&type=template&id=667e08e6&scoped=true&"
import script from "./CreateAssessmentTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./CreateAssessmentTemplateModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAssessmentTemplateModal.vue?vue&type=style&index=0&id=667e08e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e08e6",
  null
  
)

export default component.exports